const fromDtoToCategory = (item) =>
  item
    ? {
        defaultAllowance: item.default_allowance,
        defaultAllowanceHours: item.default_allowance_hours,
        color: item.color,
        id: item.id,
        isDefault: item.is_default,
        isFallback: item.is_fallback,
        isWorkingHours: item.is_working_hours,
        name: item.name,
        numberOfBookings: item.number_of_bookings,
        salonId: item.salon_id,
      }
    : item;

export default fromDtoToCategory;
